import { render, staticRenderFns } from "./ItemFilterTagList.vue?vue&type=template&id=2231ea85"
import script from "./ItemFilterTagList.vue?vue&type=script&lang=js"
export * from "./ItemFilterTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports